export default {
  EnterReceipt: 1,
  Advance: 2,
  Adjustment: 3,
  Factor: 4
}
